import {useAccessPayConfiguration, useMutationWithErrorHandling, usePost} from '@app/sdk';

export function useAddAddacsReport() {
  const post = usePost();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function addAddacsReport(data: {
    reasonCode: string;
    accountNumber: string;
    customerName: string;
    sortCode: string;
    bankAccountNumber: string;
    newSortCode: string;
    newBankAccountNumber: string;
    serviceUserNumber: string;
  }) {
    const request = {
      advices: [
        {
          payerName: data.customerName,
          reference: data.accountNumber,
          payerSortCode: data.sortCode,
          payerAccountNumber: data.bankAccountNumber,
          reasonCode: data.reasonCode,
          payerNewSortCode: data.newSortCode,
          payerNewAccountNumber: data.newBankAccountNumber,
        },
      ],
      serviceUserNumber: data.serviceUserNumber
    };
    return await post(`${accessPayConfig?.baseUrl}/debug/reports/addacs`, request);
  }

  return useMutationWithErrorHandling({
    mutationFn: addAddacsReport,
  });
}
